import { useState } from 'react'
import './style.css'
import { formatOdds, formatSize, formatSportLimit, sortSections } from '../normal/fancyFormat'

/**
 * Reference `Market9` (feed dtype 9, gtype "cricketcasino", e.g. "1ST INN LAMBI ...") —
 * `.market-9` block: Min/Max + a single Back column; rows "0 Number".."9 Number".
 * Markup copies the reference template; a box is `.suspended` when its section is not "OPEN".
 */
function Market9({ market, index = 0, onBetLockClick, exposureData = {} }) {
  // Reference getClass(): flash bg-success / bg-danger when a box's odds moved since the last feed.
  const [feed, setFeed] = useState({ cur: market, old: null })
  if (market !== feed.cur) setFeed({ cur: market, old: feed.cur })

  if (!market) return null
  const mname = market.mname || market.marketName || market.name || ''
  const sections = sortSections(market.section || [])
  const oldSections = sortSections(feed.old?.section || [])
  const marketOn = Number(market.gscode) === 1
  const backsOf = (section) =>
    (section?.odds || []).filter((o) => String(o.otype || '').toLowerCase() === 'back')
  const bookOf = (nat) => exposureData[nat] ?? exposureData[String(nat || '').trim()]

  const boxClass = (section, o, i) => {
    const old = backsOf(oldSections[i]).find((x) => x.tno === o.tno)
    const prev = old ? old.odds : o.odds
    const flash = prev < o.odds ? ' bg-success' : prev > o.odds ? ' bg-danger' : ''
    return `bl-box back${section.gstatus !== 'OPEN' ? ' suspended' : ''}${Number(o.odds) === 0 ? ' no-val' : ''}${flash}`
  }

  return (
    <div className="market-9">
      <div className="bet-table">
        <div className="bet-table-header">
          <div className="nation-name" data-toggle="collapse" data-target={`#market${index}`} aria-expanded="true">
            <span title={mname}>{`\n                    ${mname}\n                `}</span>
          </div>{' '}
          <div className="float-right">
            <a
              href="javascript:void(0)"
              className="btn btn-back"
              onClick={(e) => {
                e.preventDefault()
                if (onBetLockClick) onBetLockClick(mname)
              }}
            >
              Bet Lock
            </a>
          </div>
        </div>{' '}
        <div
          id={`market${index}`}
          data-title={market.status}
          className={`bet-table-body collapse show${marketOn ? '' : ' suspendedfull'}`}
        >
          <div className="bet-table-row">
            <div className="text-right nation-name">
              {sections.length > 0 && (
                <span className="max-bet">
                  {'\n                        Min:'}<span>{formatSportLimit(sections[0].min)}</span>
                  {' \n                        Max:'}<span>{formatSportLimit(sections[0].max)}</span>
                </span>
              )}
            </div>{' '}
            <div className="back bl-title d-none-mobile">Back</div>
          </div>{' '}
          {sections.map((section, i) => {
            const book = bookOf(section.nat)
            const backs = backsOf(section).sort((a, b) => b.tno - a.tno)
            return (
              <div key={`web${i}`} className="bet-table-row">
                <div className="nation-name d-none-mobile">
                  <p>{section.nat}</p>{' '}
                  <p className="mb-0 float-left" style={{ color: Number(book) > 0 ? 'green' : 'red' }}>
                    {book || 0}
                  </p>{' '}
                  <p className="mb-0 float-right d-none">0</p>
                </div>{' '}
                {backs.map((o) => (
                  <div key={`backodds${o.tno}`} className={boxClass(section, o, i)}>
                    <span className="d-block odds">{formatOdds(o.odds)}</span>{' '}
                    {Number(o.size) !== 0 && <span className="d-block">{formatSize(o.size)}</span>}
                  </div>
                ))}
              </div>
            )
          })}
        </div>
      </div>{' '}
      {market.rem ? <div className="remark">{market.rem}</div> : null}
    </div>
  )
}

export default Market9
